var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaff2D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 62.57 182.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#916657;}.cls-2{fill:#ceedf9;}.cls-3{fill:#232323;}.cls-4{fill:#004568;}.cls-5{fill:#0d5278;}.cls-6{fill:#bbe4f1;}.cls-7{fill:#3f1e08;}"), /*#__PURE__*/React.createElement("symbol", {
    id: "OfficeMan_01b",
    "data-name": "OfficeMan_01b",
    viewBox: "0 0 62.57 182.59"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.71,80.23,7.4,84.61l-3.76,1.3s-4.54,5.4-3.48,6,4.12-2.12,4.12-2.12-4.6,6.17-3.93,6.9C2.5,99,6.28,96.38,7.22,95.22c1.27-1.59,2.38-2.37,3.86-5.44,1.75-3.6,3.8-8.09,3.89-8.34.17-.47,1.65-3.3,1.65-3.3L10.83,76.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.05,29.9c-5.58-.57-7.88,3.54-8.93,9.1s-1.28,22.45-1.28,22.45L7.08,83.29c0,.51,6.32,3.33,6.32,3.33,3.25-3.35,9.36-17.68,10.19-20.73.67-2.41,3.26-19.48,3.61-24.7S29,30.41,24.05,29.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.7,156.46c0,2.35.7,5.39,0,6.23s-5.78,1.35-8.23,2.86-1.75,3-6.48,3.54c-5.77.67-8.75-1.69-4-4.55,5-3,6.3-3.7,9.45-8.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M17.39,80.49c-.35,8.25,1.93,35.88,2.28,45.65s.7,25.77.35,29.47,11,6.07,11.38.51-.7-22.74-.53-32.51,2.45-41.1,2.45-41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.49,166c-.18,4.55,1.92,9.43.17,12.8s-5.78,4-8.4,3.71-3-4-2.1-6.91,2.45-7.07,3-9.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.91,82.79c.88,10.61,1.19,39.46,2.45,47.84,1.58,10.44,1.75,29.81,1.4,34.19s-11.9,6.07-11.73.84-1.22-21.39-2.27-31.49-8.58-30.83-10.33-38.41c-1.3-5.61-.52-14-.52-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M34.9,27C23.57,24.62,19.15,31.75,18.27,37s-1.23,40.42-1.4,44,10,3.87,14.35,4.21S46.28,88,46.8,82.45,49.6,49.1,49.6,42.7,49.08,30.07,34.9,27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.37,24.85c2.63.33,6.66,2.52,7.53,4.21S33,40.34,33,40.34l-4.9-6.56-5.07,4c.35-3.71,3.15-11.62,6.65-12.64S34.37,24.85,34.37,24.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.23,83.13l-4,4.21s-4.64,1.18-5.86,2.36S30,94.58,30.87,95.59s5.6-2.19,5.6-2.19a9.55,9.55,0,0,1-1,3.37c-.7.84-5.67,3.47-3.85,4.72,2.72,1.85,7.88-.84,9.63-2.36s2.8-5.56,4.38-7.07,4.72-4.64,4.72-4.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.45,34.28c-3.86.26-6.47,6.91-2.8,15.67s7.7,17.68,7.7,17.68c-.7,4.11-8.23,16.63-10,18.36a16,16,0,0,1,3.5,2.19A7.79,7.79,0,0,1,47,91.89c8.75-6.4,15.23-19.21,15.58-22.24s-4.9-20.72-6.48-25.6S51.53,33.94,46.45,34.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M39.8,26.87l-1.4-4.55c3.33-6.06,3.33-10.11,2.45-13.81S36.65.59,30.17,1.27s-9.45,3.87-10,7.58S19,24.34,21.07,26.2s5.95,2,5.95,2l1.05,5.56a17.94,17.94,0,0,0,7-2.53A19.12,19.12,0,0,0,39.8,26.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M38.4,22.32C40.76,20.64,42.78,17,43,11.88S39.8-.16,31.49,0,19.41,4.21,18.71,8s9,2.28,13.56.68a36.6,36.6,0,0,0,1.14,4.88s1.34-2.48,3.06-.92c1.32,1.18,1.49,5.81-1.4,6C35.51,20.22,38.4,22.32,38.4,22.32Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kontor_Lager_-_Handlinger",
    "data-name": "Kontor & Lager - Handlinger"
  }, /*#__PURE__*/React.createElement("use", {
    width: 62.57,
    height: 182.59,
    xlinkHref: "#OfficeMan_01b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaff2D);
export default __webpack_public_path__ + "static/media/staff-2-d.0ce2e0fade8f93a6b64fe3eda9291fdf.svg";
export { ForwardRef as ReactComponent };